import { render, staticRenderFns } from "./FotosTeoricas.vue?vue&type=template&id=41207b0e"
import script from "./FotosTeoricas.vue?vue&type=script&lang=js"
export * from "./FotosTeoricas.vue?vue&type=script&lang=js"
import style0 from "./FotosTeoricas.vue?vue&type=style&index=0&id=41207b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports